import { useShowSuccess, useShowError } from 'hooks/useToast'
import { useCreateProductClassMutation } from '../../../../graphql'

export default function useCreateProductClassHandler( options?: any ) {
	const [ createProductClass ] = useCreateProductClassMutation( options )
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( catClass: string, categoryName: string, classification: string ) => {
		const result = await createProductClass( { variables: {
			catClass,
			categoryName,
			classification,
		} } )
		if ( result.data?.createProductClass?.success ) {
			showSuccess( `createInventoryLocationSuccess${Date.now()}`, result.data?.createProductClass?.message ?? 'Successfully created product class!' )
		} else {
			showError( `createInventoryLocationError${Date.now()}`, result.data?.createProductClass?.message ?? 'Sorry, an error occurred' )
		}
	}
}
